import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientReorderCompletePage } from '@/feature/hotline/client/detail/reorder/complete/page/HotlineClientReorderCompletePage';
/**
 * 匿名ホットライン投稿 完了
 */
export const HotlineClientReorderComplete = () => (_jsx(HotlineClientReorderCompletePage, {}));
